import { useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg } from "./useAuthedHttp";

export const PeoplePanel = ({ call }) => {
  const [data, setData] = useState({ roles: [], users: [] });
  const load = () => call("get", "/users").then(setData).catch(() => {});
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const change = async (uid, role) => {
    try { await call("patch", `/users/${uid}/role`, { role }); toast.success("Role updated"); load(); }
    catch (e) { toast.error(errMsg(e, "Could not change role")); }
  };
  return (
    <section className="rounded-2xl bg-white border border-[#1C242B]/10 p-6" data-testid="people-panel">
      <h2 className="font-display font-bold text-lg">Signed-in people</h2>
      <p className="text-sm text-slate-500 mt-1">Admins manage reviewers and see every language. Members only see languages assigned to their email.</p>
      <ul className="mt-4 divide-y divide-[#1C242B]/10">
        {data.users.map((u) => (
          <li key={u.user_id} className="py-3 flex items-center gap-3 text-sm" data-testid={`person-row-${u.user_id}`}>
            <span className="font-medium">{u.name || (u.emails || [])[0] || u.user_id}</span>
            <span className="text-slate-500 truncate">{(u.emails || []).join(", ")}</span>
            <select value={u.role} onChange={(e) => change(u.user_id, e.target.value)} data-testid={`person-role-${u.user_id}`}
              className="ml-auto rounded-full border border-[#1C242B]/15 bg-white px-3 py-1.5 text-sm">
              {data.roles.map((r) => <option key={r} value={r}>{r}</option>)}
            </select>
          </li>
        ))}
      </ul>
    </section>
  );
};
